import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { useKeyHandler } from '@/libs/validator/hooks/use-key-handler';
import { computed } from 'vue';

interface Props {
  keys: Array<string|number>|string|number;
  nested?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ValidationKeyObserver',
  props: {
    keys: null,
    nested: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  keys: Array<string|number>|string|number;
  nested?: boolean;
}



const handler = useKeyHandler(computed(() => ({
  keys: Array.isArray(props.keys) ? props.keys : [props.keys],
  nested: props.nested || false,
})));

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    erorrs: _unref(handler).errors,
    errorMessages: _unref(handler).errorMessages,
    hasErrors: _unref(handler).hasErrors,
    firstError: _unref(handler).firstError,
    firstErrorMessage: _unref(handler).firstErrorMessage
  })
}
}

})